import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ButtonLoaderComponent } from '../../../../shared/components/button-loader/button-loader.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { InputWrapperComponent } from '../../../../shared/components/input-wrapper/input-wrapper.component';
import { CategoryModel } from '../../../../shared/models/category.model';
import { CategoryService } from '../../../../shared/services/category.service';
import { SharedModule } from '../../../../shared/shared.module';

@Component({
  selector: 'app-add-edit-category',
  standalone: true,
  templateUrl: './add-edit-category.component.html',
  styleUrl: './add-edit-category.component.scss',
  imports: [
    ButtonComponent,
    ButtonLoaderComponent,
    SharedModule,
    InputWrapperComponent,
  ],
})
export class AddEditCategoryComponent implements OnInit, OnDestroy {
  @Input() editCategory: CategoryModel | null = null;
  @Output() onUpdate: EventEmitter<void> = new EventEmitter();
  @Output() onClose: EventEmitter<void> = new EventEmitter();

  categoryForm: FormGroup = this.fb.group({
    name: ['', [Validators.required]],
    pageTitle: ['', [Validators.required]],
  });
  isLoading: boolean = false;
  initialLoading: boolean = false;
  subscription: Subscription = new Subscription();
  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private toastr: ToastrService // private activatedRoute: ActivatedRoute, // private router: Router
  ) {}

  ngOnInit(): void {
    this.init();
  }
  init() {
    this.setInititalFormValue();
  }

  onSubmit() {
    if (this.categoryForm.invalid) {
      this.categoryForm.markAllAsTouched();
      return;
    }
    this.isLoading = true;
    if (this.editCategory) {
      this.categoryService
        .updateCategory(this.editCategory.id, { ...this.categoryForm.value })
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.toastr.success('Category updated successfully!');
            this.onUpdate.emit();
          },
          error: (err) => {
            this.isLoading = false;
            this.toastr.error(
              err?.error?.message || err.message || 'Something went wrong!'
            );
          },
        });
    } else {
      this.categoryService
        .addCategory({ ...this.categoryForm.value })
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.toastr.success('Category added successfully!');
            this.onUpdate.emit();
          },
          error: (err) => {
            this.isLoading = false;
            this.toastr.error(
              err?.error?.message || err.message || 'Something went wrong!'
            );
          },
        });
    }
  }

  setInititalFormValue() {
    this.categoryForm.get('name')?.setValue(this.editCategory?.name);
    this.categoryForm
      .get('pageTitle')
      ?.setValue(this.editCategory?.pageTitle ?? '');
  }

  handleClose() {
    this.onClose.emit();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
